export default __webpack_public_path__ + "static/media/icon-account-type-clever.2f56a826.svg";